import { render, staticRenderFns } from "./UIDeletedPost.vue?vue&type=template&id=6c9226e0&scoped=true"
import script from "./UIDeletedPost.vue?vue&type=script&lang=js"
export * from "./UIDeletedPost.vue?vue&type=script&lang=js"
import style0 from "./UIDeletedPost.vue?vue&type=style&index=0&id=6c9226e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9226e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
